import script from "./GameViewport.vue?vue&type=script&setup=true&lang=js"
export * from "./GameViewport.vue?vue&type=script&setup=true&lang=js"

import "./GameViewport.vue?vue&type=style&index=0&id=0e06cad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e06cad2"]])

export default __exports__